export default {
  namespaced: true,
  state: {
    all: [],
    loading: false
  },
  getters: {
    all: state => state.all,
    find: state => id => state.all.find(experience => experience.id == id),
    loading: state => state.loading
  },
  mutations: {
    startLoading(state) {
      state.loading = true
    },
    stopLoading(state) {
      state.loading = false
    },
    setAll(state, experiences) {
      state.all = experiences.map(exp => Object.assign(exp, { loading: false }))
      state.loading = false
    },
    set(state, experience) {
      state.all = state.all.filter(o => o.id != experience.id)
      state.all.push(experience)
    },
    remove(state, id) {
      state.all = state.all.filter(o => o.id != id)
    }
  },
  actions: {
    fetchAll({ commit }) {
      commit('startLoading')
      return Vue.$http
        .get('candidate/invites')
        .then(response => commit('setAll', response.data), response => commit('stopLoading'))
    }
  }
}
